import _ from 'lodash';
import { push } from 'react-router-redux';
import { getCurrentLocation } from '../selectors/location-history-selectors';
import { getCategories } from '../selectors/categories-selectors';
import detectRoute, { USER_PROFILE, COMMENT_EDIT_PAGE } from '../services/detect-route';

export default () => (dispatch, getState) => {
  const state = getState();
  const categories = getCategories(state);
  const hasOneCategory = categories.length === 1;
  const currentLocation = getCurrentLocation(state);
  const route = detectRoute(currentLocation);

  const parts = _.trim(currentLocation.pathname, '/').split('/');
  parts.pop();

  if (route === USER_PROFILE || route === COMMENT_EDIT_PAGE) {
    parts.pop();
  }
  if (hasOneCategory && parts.length === 0) {
    parts.push(categories[0].slug);
  }
  const path = '/' + parts.join('/');

  return dispatch(push(path));
};



// WEBPACK FOOTER //
// ./app/actions/go-back.js